import { CredentialResponse } from '@react-oauth/google'
import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'
import { CanvaProps, ItemDataMap } from 'store/types'

export const googleCredentialAtom = atomWithStorage<CredentialResponse | null>('googleCredential', null)

export const productAtom = atom<number | undefined>(undefined)

export const canvaPropsAtom = atomWithStorage<CanvaProps>('canvaProps', {
  backgroundColor: '#FFF'
})

export const itemsDataAtom = atomWithStorage<ItemDataMap>('itemsData', {})

export const selectedItemIdAtom = atom<string | undefined>(undefined)

export const higherZIndexAtom = atom(0)
